import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useNeighborhoodsByCity(cityId?: string) {
  return useQuery({
    queryKey: ['neighborhoods', cityId],
    enabled: !!cityId,
    queryFn: async () => {
      const { data } = await supabase
        .from('neighborhoods')
        .select('*')
        .eq('is_active', true)
        .eq('city_id', cityId!)
        .order('display_order')
        .order('name');
      return data || [];
    },
  });
}

export function useNeighborhoodBySlug(citySlug?: string, neighborhoodSlug?: string) {
  return useQuery({
    queryKey: ['neighborhood', citySlug, neighborhoodSlug],
    enabled: !!citySlug && !!neighborhoodSlug,
    queryFn: async () => {
      const { data: city } = await supabase
        .from('cities')
        .select('*')
        .ilike('name', citySlug!.replace(/-/g, ' '))
        .maybeSingle();
      if (!city) return null;
      const { data: n } = await supabase
        .from('neighborhoods')
        .select('*')
        .eq('city_id', city.id)
        .eq('slug', neighborhoodSlug!)
        .maybeSingle();
      if (!n) return null;
      return { ...n, city };
    },
  });
}

export function useNeighborhoodAmenities(id?: string) {
  return useQuery({
    queryKey: ['neighborhood-amenities', id],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await supabase
        .from('neighborhood_amenities')
        .select('*')
        .eq('neighborhood_id', id!)
        .order('display_order');
      return data || [];
    },
  });
}

export function useNeighborhoodGuideSections(id?: string) {
  return useQuery({
    queryKey: ['neighborhood-sections', id],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await supabase
        .from('neighborhood_guide_sections')
        .select('*')
        .eq('neighborhood_id', id!)
        .order('display_order');
      return data || [];
    },
  });
}

export function useNeighborhoodStats(id?: string) {
  return useQuery({
    queryKey: ['neighborhood-stats', id],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await supabase
        .from('neighborhood_stats_view' as any)
        .select('*')
        .eq('neighborhood_id', id!)
        .maybeSingle();
      return data;
    },
  });
}

export function citySlug(name: string) {
  return name.toLowerCase().replace(/\s+/g, '-');
}
